import Translations from './translations';
import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';

let initialised = false;

const initialise = () => {
  if (initialised) {
    return i18n
  }
  return i18n
    .use(reactI18nextModule)
    .init({
      // The default language
      fallbackLng: 'en',

      // The allowed languages
      whitelist: [
        'en'
      ],

      resources: Translations,

      // Namespaces to load
      ns: [
        // Have a common namespace used around the full app
        'common'
      ],
      // Namespace to be used if not provided when fetching a translation
      defaultNS: 'common',

      // Logs info level to console output. Helps finding issues with loading not working.
      debug: true,

      // cache: {
      //   enabled: true
      // },

      interpolation: {
        // Not needed for react as it does escape per default to prevent xss
        escapeValue: false
      }
    });
};

export default initialise;


// WEBPACK FOOTER //
// ./src/i18n/index.js